<template>
  <q-card flat :style="!$q.screen.lt.md && isDialog?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="row items-center q-pb-none" v-if="isDialog">
      <div>
        {{ selectedCustomer.Cs_Name }}
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>

    <q-card-section class="no-padding">
      <q-table
          :data="itemsOptions"
          row-key="Sale_Num"
          wrap-cells
          flat
          :filter="filter"
          :pagination.sync="pagination">
        <template v-slot:header>
          <q-input type="search" label="جستجو..." v-model="filter" filled :dense="$q.screen.lt.md">
            <template v-slot:append>
              <q-btn round flat icon="filter_alt" @click="showFilterDialog">
                <q-tooltip>
                  فیلتر نمودن اطلاعات
                </q-tooltip>
              </q-btn>
            </template>
          </q-input>

        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class" v-if="props.row.Sale_State === sale_state">
            <q-td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <div class="row">
                    <div v-if="showOnlyExitDocument===false" :class="$q.screen.lt.md?'col-1 q-mr-md':'q-mr-md'">
                      <q-btn round dense color="indigo" padding="none" size="lg" icon="info"
                             @click="showDetails(props.row)"/>
                      <q-space/>
                      <q-btn v-if="props.row.Sale_State===0" flat padding="none" size="lg" round class="q-mt-xs"
                             color="positive" icon="check"
                             @click="setSaleStateFlag(props.row.Sale_Num)">
                        <q-tooltip>
                          تایید فاکتور
                        </q-tooltip>
                      </q-btn>
                      <q-space/>
                      <q-btn round flat icon="timeline" color="indigo" @click="showOrderTimeLine(props.row)">
                        <q-tooltip>
                          رهگیری سفارش
                        </q-tooltip>
                      </q-btn>
                      <q-space/>
                      <q-btn flat round class="q-mt-xs"
                             color="indigo"
                             icon="print"
                             v-if="props.row.Sale_Kind===1"
                             @click="printfactor(props.row)">
                        <q-tooltip>
                          چاپ فاکتور
                        </q-tooltip>
                      </q-btn>
                      <q-space/>
                      <q-btn
                          v-if="props.row.Sale_Kind===1 && $store.state.roles.some(v=>['admin','can_delete_factor'].includes(v))"
                          flat round class="q-mt-xs"
                          color="negative" icon="delete"
                          :disable="props.row.LastTraceinfo!=='حذف' || props.row.LastTraceinfo==='سند حسابداری زده شد'"
                          @click="deleteFactor(props.row)">
                        <q-tooltip>
                          حذف فاکتور
                        </q-tooltip>
                      </q-btn>
                      <q-space/>
                      <q-btn
                          flat
                          round
                          color="deep-orange"
                          icon="assignment_return"
                          @click="showReturnOrderDialog(props.row)"
                          v-if="props.row.Sale_Kind===1 && props.row.LastTraceinfo==='برگشت سفارش' && $store.state.roles.some(v=>['admin','can_return_factor'].includes(v)) && !props.row.BaseSale_Num">
                        <q-tooltip>
                          صدور سند برگشت
                        </q-tooltip>
                      </q-btn>
                      <q-space/>
                      <q-btn
                          v-if="props.row.Sale_Kind===1 && props.row.CustomerRequestID && $store.state.roles.some(v=>['admin','can_send_factor'].includes(v))"
                          round flat icon="mail" color="indigo"
                          @click="sendFactorLink(props.row.CustomerRequestID, props.row.Cs_Mobile,'فاکتور',props.row.Cs_Name, props.row.Order_Num)">
                        <q-tooltip>
                          ارسال برای طرف معامله
                        </q-tooltip>
                      </q-btn>
                      <q-btn icon="attach_file" color="blue-grey" flat round
                             @click="downloadAttachment(props.row)"
                             v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                               && props.row.HasAttachment">
                        <q-tooltip>
                          دانلود ضمیمه
                        </q-tooltip>
                      </q-btn>
                    </div>
                    <div class="col-10">
                      <div class="row">
                        <div class="col">
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                  icon="qr_code">فاکتور ({{ props.row.Sale_Num }})
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                  icon="qr_code">سفارش ({{ props.row.Order_Num }})
                          </q-chip>
                          <q-chip clickable @click="showExitDocumentDetails(props.row)"
                                  :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                                  icon="qr_code">حواله ({{ props.row.Hava_Num }})
                          </q-chip>
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="red" icon="event" outline>تاریخ فاکتور
                            ({{ props.row.Sale_Date }})
                          </q-chip>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <q-chip :size="$q.screen.lt.md?'md':'md'" square color="purple" icon="functions"
                                  text-color="white">
                            {{ props.row.Sale_Count }} عدد
                          </q-chip>
                          <q-chip v-if="showOnlyExitDocument===false" :size="$q.screen.lt.md?'md':'md'" square
                                  color="green-14" icon="attach_money"
                                  text-color="white">
                            {{ props.row.Sale_Pay | toCurrency }} ریال
                          </q-chip>
                        </div>
                      </div>
                      <div class="row">
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">{{
                            props.row.CompName
                          }}
                        </q-chip>
                        <q-chip clickable :size="$q.screen.lt.md?'md':'md'" square icon="person"
                                @click="showCustomerInfo(props.row)">
                          {{ props.row.Cs_Name }}
                        </q-chip>
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="support_agent">
                          {{ props.row.UserName }}
                        </q-chip>
                      </div>
                      <div class="row">
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                          {{ props.row.City_Name }}
                        </q-chip>
                        <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                          {{ props.row.State_Name }}
                        </q-chip>
                      </div>
                    </div>
                  </div>
                </q-card-section>
                <q-card-section class="no-padding">
                  <div class="row">
                    <div class="col-md-6 col-xs-12">
                      <q-banner rounded v-if="props.row.LastTraceinfo" dense
                                :class="props.row.LastTraceinfo==='حذف'?'bg-red-8 text-white':'bg-blue-8 text-white'"
                                row.Sale_Num>
                        {{ props.row.LastTraceinfo === 'حذف' ? 'لطفا از سیستم حذف گردد.' : props.row.LastTraceinfo }}
                        <div
                            v-if="props.row.ReasonDescription && props.row.ReasonDescription!==props.row.LastTraceinfo">
                          <q-separator color="white"/>
                          {{ props.row.ReasonDescription }}
                        </div>
                      </q-banner>
                    </div>
                  </div>
                </q-card-section>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <factor-details :sale-state="selectedFactor.Sale_State" :sale-num="parseInt(selectedSaleNum)"
                      :factor-items="factorItems"
                      :sale-kind="selectedFactor.Sale_Kind"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :sale-num="parseInt(selectedSaleNum)" :sale-date="selectedSaleDate" @refresh-data="changeRow"
                     :remain-ordered="false"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="orderTraceFilterDialog">
      <OrderTraceFilterEditor :input-companies.sync="filterInfo.selectedCompanies"
                              :input-states.sync="filterInfo.selectedStates"
                              :input-cities.sync="filterInfo.selectedCities"
                              @apply-filter="applyFilter"/>
    </q-dialog>
    <q-dialog v-model="exitDocumentDialog">
      <HavaDetails :sale-num="selectedFactor.Sale_Num"
                   :hava_num="selectedFactor.Hava_Num"
                   :store_id="[1,2,3,4,5,6]"
                   :sale-kind="selectedFactor.Sale_Kind"/>
    </q-dialog>
    <q-dialog maximized v-model="returnOrderDialog">
      <IssueReturnOrder :cs-i-d="selectedFactor.Cs_ID" :sale-num="selectedFactor.Sale_Num"
                        :hava-num="selectedFactor.Hava_Num" @refresh-data="closeReturnOrderDialog"/>
    </q-dialog>

    <q-dialog v-model="factorPrintDialog">
      <FactorPrintDialog :factor-info="selectedFactor" title="چاپ فاکتور"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import FactorDetails from "@/components/Factor/FactorDetails";
import CustomerInfo from "@/components/customers/CustomerInfo";
import OrderTraceFilterEditor from "@/components/OrderTrace/OrderTraceFilterEditor";
import EventBus from "@/event-bus";
import HavaDetails from "@/components/customers/HavaDetails";
import IssueReturnOrder from "@/components/Remittance/IssueReturnOrder.vue";
import FactorPrintDialog from "@/components/PrintDialogs/FactorPrintDialog.vue";

export default {
  name: "FactorHistory",
  components: {
    FactorPrintDialog,
    IssueReturnOrder, HavaDetails, OrderTraceFilterEditor, CustomerInfo, FactorDetails, OrderTimeLine
  },
  props: {
    orderHistoryList: {
      type: Array,
      default: ()=> []
    },
    defaultSaleState: {},
    isDialog: {
      type: Boolean
    },
    showOnlyExitDocument: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      returnOrderDialog: false,
      exitDocumentDialog: false,
      orderTraceFilterDialog: false,
      filterInfo: {
        selectedCompanies: null,
        selectedStates: null,
        selectedCities: null
      },
      items: [],
      itemsOptions: [],
      filter: '',
      selectedCustomer: '',
      selectedFactor: '',
      customerInfoDialog: false,
      factorItems: [],
      showOrderDetailsDialog: false,
      showTimeLineDialog: false,
      selectedSaleNum: '',
      sale_state: false,
      pagination: {
        rowsPerPage: 10
      },
      selectedSaleDate: ''
    }
  },
  methods: {
    ...mapActions({
      setSaleState: 'Orders/setSaleState',
      setFinalOrder: 'Orders/setSaleFinalState',
      getFactorItems: 'Orders/getFactorItems',
      getCustomerInfo: 'Customers/get_customer_info',
      deleteFactorBySaleNum: 'Orders/deleteFactor',
      SendSMS: 'send_sms_by_user',
      downloadFile: 'Orders/downloadFile',
    }),
    closeReturnOrderDialog() {
      this.returnOrderDialog = false;
    },
    showReturnOrderDialog(row) {
      if (row.LastTraceinfo !== 'برگشت سفارش') {
        this.$q.notify({
          message: 'به دلیل عدم ثبت برچسب برگشت سفارش امکان ثبت سند برگشت میسر نمی باشد',
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.selectedFactor = row
        this.returnOrderDialog = true;
      }
    },
    downloadAttachment(args) {
      this.downloadFile(
          {
            filePath: `SaleOrders/${args.Sale_Num}_${args.Sale_Kind}.pdf`,
            fileExtension: 'pdf',
            mimeType: 'application/pdf'
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    },
    showExitDocumentDetails(row) {
      this.selectedFactor = row
      this.exitDocumentDialog = true
    },
    async sendFactorLink(requestid, phoneNo, ty, customerName, sale_num) {
      this.$q.dialog({
        title: 'نحوه ارسال',
        message: 'نحوه ارسال فاکتور را مشخص کنید؟',
        persistent: false,
        ok: {
          label: 'لینک فاکتور/پیش فاکتور'
        },
        cancel: {
          label: 'لینک پرداخت',
          color: 'green',
          flat: true
        },
      }).onOk(() => {
        this.SendSMS({
          phoneNo: phoneNo,
          Sale_Num: sale_num,
          Message: `نوران، سلام \n مشتری عزیز (${customerName}) شما می توانید از طریق لینک زیر اطلاعات ${ty} خود را مشاهده نمایید. لازم به ذکر است مدت اعتبار دسترسی به  ${ty} 1 روز می باشد \nhttps://ecapp-report.norl.ir/CustomerViewer?requestid=${requestid}`
        }).then(() => {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            message: 'پیامک ارسال گردید',
            position: 'top'
          })
        }).catch(() => {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            message: 'پیامک ارسال نگردید',
            position: 'top'
          })
        })
      }).onCancel(() => {
      }).onDismiss(() => {
      })
    },
    changeRow(arg) {
      let founded = this.itemsOptions.filter(item => item.Order_Num === arg.data.Sale_Num)
      if (founded && founded.length > 0) {
        founded[0].LastTraceinfo = arg.data.title
        founded[0].ReasonDescription = arg.data.ReasonDescription
      }

      founded = this.items.filter(item => item.Order_Num === arg.data.Sale_Num)
      if (founded && founded.length > 0) {
        founded[0].LastTraceinfo = arg.data.title
        founded[0].ReasonDescription = arg.data.ReasonDescription
      }
    },
    applyFilter(arg) {
      this.filterInfo.selectedCompanies = arg.selectedCompanies === null || arg.selectedCompanies === undefined ? [] : arg.selectedCompanies
      this.filterInfo.selectedStates = arg.selectedStates === null || arg.selectedStates === undefined ? [] : arg.selectedStates
      this.filterInfo.selectedCities = arg.selectedCities === null || arg.selectedCities === undefined ? [] : arg.selectedCities
      this.filterInfo.selectedGoodsGroup = arg.selectedGoodsGroup === null || arg.selectedGoodsGroup == null === undefined ? [] : arg.selectedGoodsGroup
      this.filterInfo.selectedGoods = arg.selectedGoods == null || false ? [] : arg.selectedGoods

      let comIDs = this.filterInfo.selectedCompanies.map(record => record.CompID)
      let stateIDs = this.filterInfo.selectedStates.map(record => record.State_ID)
      let cityIDs = this.filterInfo.selectedCities.map(record => record.City_ID)
      let goodsGroupIDs = this.filterInfo.selectedGoodsGroup.map(record => record.Group_ID)
      let goodsIDs = this.filterInfo.selectedGoods.map(record => record.Goods_ID)

      this.itemsOptions =
          this.items.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )
    },
    showFilterDialog() {
      this.orderTraceFilterDialog = true
    },
    printfactor(item) {
      this.selectedFactor = item
      this.factorPrintDialog = true
    },
    deleteFactor(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از حذف فاکتور اطمینان دارید؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteFactorBySaleNum({
          saleNum: row.Sale_Num,
          saleKind: row.Sale_Kind
        }).then(() => {
          this.orderHistoryList = this.orderHistoryList.filter(item => item.Sale_Num !== row.Sale_Num)
        })
      })
    },
    showDetails(row) {
      this.getFactorItems({
        sale_num: row.Sale_Num,
        sale_kind: row.Sale_Kind
      }).then((res) => {
        this.factorItems = res;
        this.selectedSaleNum = row.Sale_Num;
        this.selectedFactor = row
        this.showOrderDetailsDialog = true;
      })
    },
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
    SetFinalSaleState(row) {
      this.setFinalOrder(row.Sale_Num).then((res) => {
        if (res.data.msg === 'success') {
          this.$q.notify({
            message: `فاکتور ${row.Sale_Num}تایید گردید `,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          row.Sale_StateModir = 1
        }
      })
    },
    setSaleStateFlag(sale_num) {
      this.$q.dialog({
        title: 'تاییدیه نقد بودن خرید',
        message: 'آیا خرید طرف معامله نقدی می باشد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: true
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `فاکتور ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      }).onCancel(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: false
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `فاکتور ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      })
    },
    showOrderTimeLine(row) {
      this.selectedSaleNum = row.Order_Num;
      this.selectedSaleDate = row.Sale_Date
      this.showTimeLineDialog = true;
    },
  },
  created() {
    if (this.defaultSaleState === undefined) {
      this.sale_state = 1

    } else {
      this.sale_state = this.defaultSaleState
    }
  },
  mounted() {
    EventBus.$on('invoke-factor-list', payload => {
      this.items = payload;
      this.itemsOptions = this.items
    });
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
